import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Helmet } from "react-helmet";
import {observer} from 'mobx-react';

import PersonIdentities from '../elements/PersonIdentities'
import EventList from "../../Events/elements/EventList";
import TalkList from "../elements/TalkList";

import styles from './Show.sass';

@observer
export default class ShowPage extends PureComponent {

    constructor(props, context) {
        super(props, context);

        this.handlePrevLinkClick = this.handlePrevLinkClick.bind(this);
        this.handleNextLinkClick = this.handleNextLinkClick.bind(this);
    }

    componentWillMount() {
        if (!this.props.store.bySlug.get(this.props.match.params.slug)) {
            this.props.store.fetchBySlug(this.props.match.params.slug)
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.slug !== this.props.match.params.slug) {
            await this.preparePersonData(nextProps.match.params.slug);
        }
    }

    async handlePrevLinkClick() {
        if (!this.person || !this.person.previous) {
            return
        }

        await this.preparePersonData(this.person.previous.slug);

        this.props.history.push('/prelegenci/' + this.person.previous.slug);
    }

    async handleNextLinkClick() {
        if (!this.person || !this.person.next) {
            return
        }

        await this.preparePersonData(this.person.next.slug);

        this.props.history.push('/prelegenci/' + this.person.next.slug);
    }

    async preparePersonData(slug) {
        if (!this.props.store.bySlug.get(slug)) {
            await this.props.store.fetchBySlug(slug)
        }
    }

    render() {

        const person = this.person = this.props.store.bySlug.get(this.props.match.params.slug);

        if (!person) {
            return null
        }

        return (
            <div className={classNames(styles.root, 'largest grid')}>
                <Helmet>
                    <title>{person.name.given + ' ' + person.name.family}</title>
                </Helmet>

                <article className={classNames(styles.bio, 'xlarge-4 column exposed-soft skewed border-top border-simpler')}>
                    {<span className={classNames({[styles.navInactive]: !person.previous})} onClick={this.handlePrevLinkClick} />}
                    <div>
                        <header>
                            <img src={person.photo.normal || '/img/people/__placeholder.png'} />
                            <div>
                                <h1 className="line-post line-center line-flat">
                                    <span>{person.name.given}</span>
                                    {person.name.family}
                                </h1>
                                <PersonIdentities className={styles.identities} person={person} />
                            </div>
                        </header>
                        <div className={classNames(styles.bioContent, 'g-type-major markdown')} dangerouslySetInnerHTML={{__html: person.bio.full}} />
                    </div>
                    {<span className={classNames({[styles.navInactive]: !person.next})} onClick={this.handleNextLinkClick} />}
                </article>

                <section className={classNames(styles.events, 'medium-6 xlarge-4 column')}>
                    <h3 className="g-type-title-section g-type-title-right line-flat">Wydarzenia</h3>
                    {person.events !== undefined &&
                    <EventList events={person.events}/>
                    }
                </section>

                <section className={classNames(styles.talks, 'medium-6 xlarge-4 column')}>
                    <h3 className="g-type-title-section g-type-title-left line-flat">Prezentacje</h3>
                    {person.talks !== undefined &&
                        <TalkList talks={person.talks}/>
                    }
                </section>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/People/pages/Show.js